'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const timespan=require('pulsar-utils/dist-es6/time/timespan');let

EstimatesAsOfStatusDirective=class EstimatesAsOfStatusDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/estimatesAsOfStatusDirective/estimatesAsOfStatusTemplate'}
get controller(){return EstimatesAsOfStatusDirectiveController}
get objectBindings(){return['time','timezone']}};


const FiveMinutesInMilliseconds=timespan.fromMinutes(5).totalMilliseconds();
const ThirtyMinutesInMilliseconds=timespan.fromMinutes(30).totalMilliseconds();let

EstimatesAsOfStatusDirectiveController=class EstimatesAsOfStatusDirectiveController extends BaseController{
constructor(uncaughtErrorHandler,$timeout,$scope,$interval,dateService,timeFormattingService){
super(uncaughtErrorHandler,$timeout,$scope);

this._dateService=dateService;
this._timeFormattingService=timeFormattingService;
this._$scope=$scope;
this._$interval=$interval;
this._$timeout=$timeout;

this._safeWatch('time',()=>this._updateVisualTime());
this._safeWatch('timezone',()=>this._updateVisualTime());

const timeUpdateInterval=$interval(()=>{
if(this._lastUpdate&&this._dateService.now()-this._lastUpdate.getTime()<FiveMinutesInMilliseconds){
return;
}

this._$scope.$evalAsync(()=>this._updateVisualTime());
},FiveMinutesInMilliseconds,0,!1);

this._$scope.$on('$destroy',()=>$interval.cancel(timeUpdateInterval));

this._updateVisualTime();
}

_updateVisualTime(){
this._formattedTime=tryGet(this.time).then(t=>_.exists(this.timezone)?
this._timeFormattingService.timeAndFullDateInTimezone(t,this.timezone):
this._timeFormattingService.timeAndFullDateInLocalTime(t)).
otherwise('');

this._shouldWarn=_.exists(this.time)&&this._dateService.now().getTime()-this.time.getTime()>ThirtyMinutesInMilliseconds;

this._lastUpdate=this._dateService.now();
}

get formattedTime(){
return this._formattedTime;
}


get shouldWarn(){
return this._shouldWarn;
}};


module.exports=EstimatesAsOfStatusDirective;
//# sourceMappingURL=estimatesAsOfStatusDirective.js.map
